<template>
  <div class="static-gallery-item">
    <img
      v-if="isImage"
      :src="src"
      :alt="alt"
      v-bind="$attrs"
      @load="onLoadEnd"
      @error="onLoadEnd"
    />
    <video
      v-else-if="isVideo"
      :src="src"
      v-bind="$attrs"
      @load="onLoadEnd"
      @error="onLoadEnd"
    >
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
import galleryItemLoad from '~/mixins/gallery-item-load'

export default {
  name: 'StaticGalleryItem',
  mixins: [galleryItemLoad],
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  computed: {
    isVideo() {
      return /\.(mp4|webm|ogg)/i.test(this.src)
    },
    isImage() {
      // return /\.(gif|jpe?g|tiff|png|webp|bmp)/i.test(this.src)
      return !this.isVideo
    },
  },
}
</script>
